(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("immutable2d", [], factory);
	else if(typeof exports === 'object')
		exports["immutable2d"] = factory();
	else
		root["immutable2d"] = factory();
})(window, function() {
return 